angular.module('bmsApp.settings').factory('NominalCodeSvc', function ($http, $log, $window, $q, CRUDSvc, NOMINAL_CODE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(NOMINAL_CODE_API.INDEX, params);
		}
	}

}).constant('NOMINAL_CODE_API', {
	INDEX: 'api/settings/nominalCodes/index'
});

